import { api } from './client';

export type CategoryType = 'CROP_TYPE' | 'MATERIAL_GROUP' | 'EXPENSE_CATEGORY' | 'SOIL_TYPE' | 'LOAN_REJECT_REASON' | 'UNIT_OF_MEASURE' | 'PROVINCE';
export type CategoryScope = 'GLOBAL' | 'HTX';

export interface CategoryDto {
  _id: string;
  type: CategoryType;
  scope: CategoryScope;
  htxId?: string;
  name: string;
  active: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

/** htxId is inferred server-side from the caller's JWT — the query param is only used
 * for roles that don't carry an htxId (e.g. OPS reviewing a specific HTX's list). */
export async function listCategories(type: CategoryType): Promise<CategoryDto[]> {
  return api.get<CategoryDto[]>(`/categories?type=${type}`);
}

export async function createCategory(type: CategoryType, name: string): Promise<CategoryDto> {
  return api.post<CategoryDto>('/categories', { type, name });
}
